import produce from 'immer'
import { Reducer } from 'redux'

import {
  SET_USER_DETAILS,
  SET_USER_IS_LOGGED,
  SET_USER_ROLES,
  SET_USER_IS_ADMIN,
  SET_USER_IS_CORE,
  SET_USER_IS_CLARILIS,
  SET_USER_IS_LIMITED_ACCESS,
  SET_USER_ENCRYPTION_KEYS_LOADED,
  SET_USER_IS_DOCDRAFTER,
  SET_ACCESS_ROLES
} from 'redux/actions/types'

export interface UserState {
  details: {
    email:string;
    isExternalAuth:boolean
  };
  encryptionKeysLoaded: boolean;
  isLogged: boolean;
  roles:string[];
  isAdmin:boolean;
  isCore:boolean;
  isClarilis:boolean;
  isDocDrafter:boolean;
  isLimitedAccess:boolean;
  accessRoles: string[]
}

const initialState: UserState = {
  details: { email: '', isExternalAuth: false },
  encryptionKeysLoaded: false,
  isLogged: false,
  roles: [],
  isAdmin: false,
  isCore: false,
  isClarilis: false,
  isDocDrafter: false,
  isLimitedAccess: false,
  accessRoles: []
}

const user:Reducer<UserState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return produce(state, draft => {
        draft.details = { ...action.details }
      })
    case SET_USER_IS_LOGGED:
      return produce(state, draft => {
        draft.isLogged = action.isLogged
      })
    case SET_USER_ROLES:
      return produce(state, draft => {
        draft.roles = [...action.roles]
      })
    case SET_ACCESS_ROLES:
      return produce(state, draft => {
        draft.accessRoles = [...action.accessRoles]
      })
    case SET_USER_IS_ADMIN:
      return produce(state, draft => {
        draft.isAdmin = action.isAdmin
      })
    case SET_USER_IS_CORE:
      return produce(state, draft => {
        draft.isCore = action.isCore
      })
    case SET_USER_IS_CLARILIS:
      return produce(state, draft => {
        draft.isClarilis = action.isClarilis
      })
    case SET_USER_IS_DOCDRAFTER:
      return produce(state, draft => {
        draft.isDocDrafter = action.isDocDrafter
      })
    case SET_USER_IS_LIMITED_ACCESS:
      return produce(state, draft => {
        draft.isLimitedAccess = action.isLimitedAccess
      })
    case SET_USER_ENCRYPTION_KEYS_LOADED:
      return produce(state, draft => {
        draft.encryptionKeysLoaded = action.encryptionKeysLoaded
      })
    default:
      return state
  }
}

export default user
